export default __webpack_public_path__ + "locales/nl/ArchiveDialog.json?hash=f9494dfd25b6baf07ea9c2775d5f2d15";